module.exports = __webpack_public_path__ + "img/332x454px.4776639b.png";